"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['ယခုအတွင်း', 'ယခု'],
        ['%s စက္ကန့် အကြာက', '%s စက္ကန့်အတွင်း'],
        ['1 မိနစ် အကြာက', '1 မိနစ်အတွင်း'],
        ['%s မိနစ် အကြာက', '%s မိနစ်အတွင်း'],
        ['1 နာရီ အကြာက', '1 နာရီအတွင်း'],
        ['%s နာရီ အကြာက', '%s နာရီအတွင်း'],
        ['1 ရက် အကြာက', '1 ရက်အတွင်း'],
        ['%s ရက် အကြာက', '%s ရက်အတွင်း'],
        ['1 ပတ် အကြာက', '1 ပတ်အတွင်း'],
        ['%s ပတ် အကြာက', '%s ပတ်အတွင်း'],
        ['1 လ အကြာက', '1 လအတွင်း'],
        ['%s လ အကြာက', '%s လအတွင်း'],
        ['1 နှစ် အကြာက', '1 နှစ်အတွင်း'],
        ['%s နှစ် အကြာက', '%s နှစ်အတွင်း'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=my.js.map